import { AppRoute } from '@app/core/routing/AppRoute';
import { BalenaDevicesListPage } from '@app/modules/fleet/balena-devices/screens/list/BalenaDevicesListPage';
import { UserRole } from '@mi-front/core';
import { Redirect, Route, Switch } from 'react-router-dom';

/**
 * Fleet routes: Balena devices listing at `/devices`.
 */
export function FleetRoutes() {
  return (
    <Route path="/devices">
      <Switch>
        <AppRoute
          allowedRole={[UserRole.CLIENT_ADMIN, UserRole.SUPERADMIN]}
          exact
          path="/devices"
          component={BalenaDevicesListPage}
        />
        <Redirect to="/devices" />
      </Switch>
    </Route>
  );
}
